import type { Footer as FooterData } from '@/data/types';

interface FooterProps {
  data: FooterData;
}

export function Footer({ data }: FooterProps) {
  const { contactInfo, copyrightText, copyrightYear, companyName } = data;

  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Contact Info Section */}
        <div className="py-12">
          <div className="max-w-md">
            <h4 className="text-sm font-semibold text-amber-400 mb-6 uppercase tracking-wider">
              Contact Info
            </h4>
            <div className="space-y-2 text-gray-300">
              <div className="text-base">
                {contactInfo.address}
              </div>
              <div className="text-base">
                {contactInfo.city}, {contactInfo.state} {contactInfo.zipCode}
              </div>
              <div className="text-base">
                {contactInfo.phone}
              </div>
              <div className="text-base">
                {contactInfo.maintenancePhone} (maintenance)
              </div>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="border-t border-gray-700 py-6">
          <div className="text-center text-gray-400 text-sm">
            {copyrightText} {copyrightYear}, {companyName}
          </div>
        </div>
      </div>
    </footer>
  );
}